import { useEffect, useState } from "react";
import api from "../config/api";

/**
 * Custom hook for fetching guest images upload count and user statistics
 *
 * Features:
 *   Fetches comprehensive user statistics from API including upload counts
 *
 */

const useGuestImagesUploadCount = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fetches user statistics including image upload counts from the API
   * @returns {Promise<Object|null>} - API response data or null if error occurs
   */
  const fetchGuestImagesCount = async ({showLoader =  true} = {}) => {
    showLoader && setLoading(true);
    setError(null);

    try {
      const response = await api.get(`/users/count`);
      setData(response.data);
      setLoading(false);

      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Failed to fetch guest images";

      setError(errorMessage);
      setLoading(false);

      return null;
    }
  };

  useEffect(() => {
    fetchGuestImagesCount();
  }, []);

  return {
    guestImagesCount: data, // User statistics data from API response
    loading, // Current loading state during API requests
    error, // Current error state with API failure messages
    fetchGuestImagesCount: () => fetchGuestImagesCount({showLoader: false}), // Function to manually refresh data
  };
};

export default useGuestImagesUploadCount;
